window.showModal = function (title) {
  $('.modal-body').html(setSpinner())
  $('.modal-title').text(title)
  modal.show()
}

window.hideModal = function () {
  if ($('#modal').attr('on_close_cable') != undefined){
    if ($('#modal').attr('on_close_cable') == 'synchronizationLogChannel'){ unsubscribeSynchronizationLogChannel() }
    $('#modal').removeAttr('on_close_cable')
  }
  modal.hide()
}

window.loadModal = function (params) {
  const title = params.title
  const url   = params.url
  
  showModal(title)
  $.ajax({
    url: url,
    dataType: 'script',
    success: function(res){
      $('.modal-body').html(res)
    }, 
    error: function(jqXHR){
      if (jqXHR.status == 403 || jqXHR.status == 422) {
        const json = JSON.parse(jqXHR.responseText)
        $(".modal-body").html(`
          <p class='bg-danger text-center text-white fw-bold text-sm rounded'>${json.message}</p>
        `)
      } else {
        alert("Something error!")
        console.log(jqXHR)
      }
    }
  })
}